import { render, staticRenderFns } from "./clients.vue?vue&type=template&id=1e608488"
import script from "./clients.vue?vue&type=script&lang=js"
export * from "./clients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports